import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24 }}>
          <h2 style={{ margin: 0 }}>Ops, algo de errado aconteceu... 😕</h2>
          <p style={{ opacity: 0.8 }}>
            Isso normalmente acontece quando chegou algum dado inesperado.
          </p>
          <pre style={{ whiteSpace: "pre-wrap", opacity: 0.9 }}>
            {String(this.state.error || "")}
          </pre>
          <button onClick={this.handleReload}>Recarregar</button>
        </div>
      );
    }

    return this.props.children;
  }
}
